export const QUERY__SORT_OPTIONS = 'sort-options';
export const QUERY__GEO_FILTER_OPTIONS = 'geo-filter-options';
export const QUERY__MARKETPLACE_ITEM_MAPPINGS = 'marketplace-item-mappings';
